import EnumClass, { build } from '../EnumClass';
import data, { StaffTeamId, StaffTeamData } from './data';
import * as Translations from './translations';

export class StaffTeam extends EnumClass<StaffTeamId, StaffTeamData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: STAFF_TEAMS,
  getById: getStaffTeamById,
  marshaller: StaffTeamMarshaller,
} = build<StaffTeamId, StaffTeamData, StaffTeam>('StaffTeamEnum', data, StaffTeam);
